import React from 'react';
import { Team } from '../redux/types';

type Props = {
    team: Team[];
};

const DealTeam: React.FC<Props> = ({ team }) => {
    return (
        <>
            <p className="text-[#20222B] text-2xl uppercase font-[WorkSans-Semibold] font-bold common_read_title mt-6">
                Team
            </p>
            <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 2xl:grid-cols-5 gap-4 mt-2">
                {team.map((t) => (
                    <div className="border border-[#D7D7D7] border-l border-r-0 border-b-0 border-t-0" key={t.uuid}>
                        <div
                            className="w-full h-[130px] bg-no-repeat bg-cover bg-top"
                            style={{ backgroundImage: `url(${t.imageURL})` }}
                        />
                        <div className="px-4 py-2">
                            <p className="text-[#20222B] text-[WorkSans-Semibold] font-bold text-sm">{t.name}</p>
                            <p className="text-[#747474] text-[Lato] text-xs">{t.role}</p>
                        </div>
                    </div>
                ))}
            </div>
        </>
    );
};

export default DealTeam;
